import { PageBadge } from "../recordDefinition.types";

export const accountPageBadges: PageBadge[] = [
  {
    id: "state",
    label: (record) => (record.statecode === 0 ? "Active" : "Inactive"),
    variant: (record) => (record.statecode === 0 ? "success" : "warning"),
  },
];
